export const FETCH_QUOTE_SUMMARY = 'corp-quote/approval/FETCH_QUOTE_SUMMARY';
export const FETCHING_QUOTE_SUMMARY = 'corp-quote/approval/FETCHING_QUOTE_SUMMARY';
export const FETCH_QUOTE_SUMMARY_SUCCESS = 'corp-quote/approval/FETCH_QUOTE_SUMMARY_SUCCESS';

export const FETCH_QUOTES = 'corp-quote/approval/FETCH_QUOTES';
export const FETCHING_QUOTES = 'corp-quote/approval/FETCHING_QUOTES';
export const FETCH_QUOTES_SUCCESS = 'corp-quote/approval/FETCH_QUOTES_SUCCESS';

export const SET_FILTER = 'corp-quote/SET_FILTER';

export const EXPORT_QUOTE = "corp-quote/EXPORT_QUOTE";

export type Action =
  | { type: FETCHING_QUOTE_SUMMARY }
  | { type: FETCH_QUOTE_SUMMARY_SUCCESS, data: Object }
  | { type: SET_FILTER, data: Object };



// WEBPACK FOOTER //
// ./src/features/corporate-quote/workflow/action-types.js